import { Controller } from "@hotwired/stimulus"

// Per-message read receipts. Each of the VIEWER's own messages carries a ✓ (sent)
// check; this flips to ✓✓ (seen) for every message at/older than the other party's
// read cursor. The cursor lives in a hidden `marker` target (the other party's
// last_read_at), which is REPLACED live when they read — so all checks up to that
// point flip at once, no refresh.
export default class extends Controller {
  static targets = ["marker", "check"]

  connect() {
    this.refresh()
  }

  // Fires when the marker is (re)inserted by a Turbo Stream on read.
  markerTargetConnected() {
    this.refresh()
  }

  // A newly-appended message check picks up the current cursor immediately.
  checkTargetConnected(el) {
    this.applyOne(el, this.readAt())
  }

  readAt() {
    const iso = this.hasMarkerTarget ? this.markerTarget.dataset.readAt : ""
    return iso ? Date.parse(iso) : null
  }

  refresh() {
    const at = this.readAt()
    this.checkTargets.forEach((el) => this.applyOne(el, at))
  }

  applyOne(el, at) {
    const created = Date.parse(el.dataset.createdAt)
    const seen = at != null && created <= at
    el.textContent = seen ? "✓✓" : "✓"
    el.classList.toggle("text-primary-600", seen)
    el.classList.toggle("text-secondary-400", !seen)
    el.setAttribute("data-test", seen ? "msg-seen" : "msg-sent")
  }
}
